<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Titre</span>
      </div>
      <input :value="article.titre"
             name="article_titre"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Contenu</span>
      </div>
      <textarea :value="article.contenu"
                name="article_contenu"
                disabled
                type="email"
                class="form-control">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Auteur</span>
      </div>
      <input :value="article.auteur"
             name="article_auteur"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de publication</span>
      </div>
      <input :value="article.date_publication"
             name="article_date_publication"
             disabled
             type="date"
             class="form-control">
      <input :value="article.temps_publication"
             name="article_temps_publication"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="article.date_creation"
             name="article_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="article.temps_creation"
             name="article_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="article.date_modification"
             name="article_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="article.temps_modification"
             name="article_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    article: {
      type: Object
    }
  },
  data(){
    return{}
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/articles/components/Read.vue